import type { User } from 'firebase/auth';

/**
 * E-mail-hitelesítés a kliensen — ugyanaz a szabály, mint a szerver kapujánál
 * (`server/src/lib/communityLock.ts` → `hasTrustedEmail`).
 *
 * Hitelesített, ha: a Firebase Auth annak tartja, VAGY a szerveroldali OTP
 * lefutott (`profile.emailVerified`), VAGY Google-/Apple-fiók van a fiókhoz
 * kötve — ilyenkor az OTP felesleges (Geri, #76).
 */
const TRUSTED_PROVIDERS = new Set(['google.com', 'apple.com']);

export function isEmailTrusted(user: User | null, profileVerified?: boolean): boolean {
  if (!user) return false;
  return user.emailVerified
    || profileVerified === true
    || user.providerData.some((provider) => TRUSTED_PROVIDERS.has(provider.providerId));
}

/*
  A KÖZÖSSÉGI ZÁROLÁS JELZÉSE (#76). Bármely végpont `community_locked`
  403-at adhat (szív, hozzászólás, banda-chat, banda-alapítás) — a kérés-réteg
  (`api.ts` → `request`) itt jelzi, a `CommunityLockPrompt` pedig egy helyen,
  az app gyökerében mutatja a „Hitelesítés most” lapot. Így egyik hívási helyen
  sem kell külön kezelni, és egyik sem nyelheti el csendben (mért hiba: a szív
  hiba nélkül villant vissza).
*/
type Listener = () => void;
const listeners = new Set<Listener>();
let lockPromptOpen = false;

export function notifyCommunityLocked(): void {
  if (lockPromptOpen) return;
  lockPromptOpen = true;
  listeners.forEach((listener) => listener());
}

export function closeCommunityLockPrompt(): void {
  if (!lockPromptOpen) return;
  lockPromptOpen = false;
  listeners.forEach((listener) => listener());
}

export function subscribeToCommunityLock(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function communityLockPromptOpen(): boolean {
  return lockPromptOpen;
}
